import React, { useState } from 'react'
import { StatBoxes, StatTables } from './LeaderboardPageComponents'
import { YourStatsSectionContainer } from './LeaderboardPageStyles'
import { apiURL, commonHeadersWeb } from 'src/consumer/services'
import axios from 'axios'
import { useEffect } from 'react'
import { Spinner } from 'react-bootstrap'
import { useContext } from 'react'
import { ThemeContext } from 'src/context/ThemeContext'

export default function UserStats() {
  const [userStats, setUserStats] = useState(null)
  const token = localStorage.getItem('token')
  const { theme } = useContext(ThemeContext)

  const getStats = async () => {
    try {
      const response = await axios.get(`${apiURL}/api/secure/bc/company/stats`, {
        headers: {
          Authorization: `Bearer ${token}`,
          ...commonHeadersWeb,
          'ef-user-country-code': localStorage.getItem('countryCode'),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      })
      const responseDataArray = response?.data
      responseDataArray.forEach((item) => {
        if (
          item?.id === 'longestMeditation' ||
          item?.id === 'longestBreathing' ||
          item?.id === 'longestJournal' ||
          item?.id === 'longestCourseSession'
        ) {
          if (item?.id === 'longestMeditation') {
            item.value = 4927
          }
          if (item?.id === 'longestBreathing') {
            item.value = 2355
          }
          if (item?.id === 'longestJournal') {
            item.value = 7805
          }
          if (item?.id === 'longestCourseSession') {
            item.value = 3927
          }
        } else {
          if (item?.value === 0) {
            item.value = 102;
          } else if (item?.value) {
            item.value *= 53;
          } else {
            item.value = 53;
          }
        }
      })
      setUserStats(responseDataArray)
      return response
    } catch (error) {
      console.log(error)
      return error
    }
  }

  useEffect(() => {
    getStats()
  }, [])

  return (
    <>
      {Boolean(userStats) ? (
        <YourStatsSectionContainer themeType={theme}>
          <StatBoxes data={userStats} themeType={theme} />
          <StatTables data={userStats} themeType={theme} />
        </YourStatsSectionContainer>
      ) : (
        <Spinner animation="border" variant="light" size="md" />
      )}
    </>
  )
}
